import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutRetailerNodes = function useLoggedOutRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutRetailerNodes = {
    L1: {
      Account: strictLocalize({
        id: "8viWk0",
        defaultMessage: "Account settings (e.g. update address)"
      }),
      HowFaireWork: strictLocalize({
        id: "6TLwqu",
        defaultMessage: "How does Faire work"
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: "Invoices and payments"
      }),
      Items: strictLocalize({
        id: "1qDrDS",
        defaultMessage: "Missing and damaged items"
      }),
      Orders: strictLocalize({
        id: "9QHKE5",
        defaultMessage: "Order status"
      }),
      Returns: strictLocalize({
        id: "Gi6QMt",
        defaultMessage: "Returns and refunds"
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: "General shipping questions"
      }),
      Other: strictLocalize({
        id: "8PmlMt",
        defaultMessage: "Other Retailer Issues"
      })
    },
    L2: {
      ImportFeesAndDuties: strictLocalize({
        id: "Fjt2kE",
        defaultMessage: "Import fees & Duties"
      }),
      BuyingInternational: strictLocalize({
        id: "16zI+k",
        defaultMessage: "Buying International"
      }),
      Other: strictLocalize({
        id: "mTbErA",
        defaultMessage: "Other"
      })
    }
  };
  return loggedOutRetailerNodes;
};